import Associates from "@/views/Associates.vue";

const traducciones = {
    en: {
        biografia: {
            name: "Biography",
            content: "ResiCorporation is a leader in web development for Spanish-speaking and English-speaking markets. We create and maintain exceptional, optimised, and secure websites."
        },
        contacto: {
            name: "Contact"
        },
        servicios: {
            name: "Services",
            content: "Web Development & more",
            contentServicios: "What we offer",
            desarrolloWeb: "Web Development",
            contentDesarrollo: "We build your website from scratch using clean code, without pre-made templates like those used by website builders or CMS platforms. 100% bespoke design, tailored to your brand.",
            mantenimiento: "Maintenance",
            contentMantenimiento: "First month included. After development, we offer monthly support to keep your site up to date, update features and fix any potential issues.",
            servidor: "Server",
            contentServidor: "Included in the development and monthly maintenance fees. We handle everything so your website stays online and secure."
        },
        proyectos: {
            name: "Completed Projects",
            content: "+12",
            nameProyecto: "Projects",
            nuestrosProyectos: "Our Projects",
            verSitio: "View Site"
        },
        idiomas: {
            name: "Languages",
            content: "Spanish and English"
        },
        tituloServicio: {
            name: "Contact Us",
            content: "Get in touch"
        },
        hablanos: {
            name: "Talk to Us"
        },
        escribenos: {
            name: "Write to Us",
            content: "Tell us about your project"
        },
        formulario: {
            name: "Full Name",
            contentName: "Enter your full name",
            telefono: "Phone",
            contentTelefono: "Enter your phone number",
            contentEmail: "Enter your email",
            proyecto: "Project",
            contentProyecto: "Describe what you are looking for...",
            enviar: "Send"
        },
        desarrollo: {
            habilidades: "Skills",
            nuestrasHabilidades: "Our Skills English",
            front: "Front-end Development",
            back: "Back-end development"
        },
        inicio: {
            name: "Home",
            associates: "Associates",
            blog: "Blog",
        },
        hero: {
            titulo: "Modern digital solutions",
            subtitulo: "We create modern, affordable, and optimised websites for your business. No builders or CMS platforms - no WordPress, Shopify, Wix, etc. Just real development with clean code, tailored 100% to you.",
            cta: "Request a quote",
        },
        testimonials: {
            name: "Testimonial",
            content: "My client saying",
            test1: "I obtained exactly what I was looking for with Resi Corporation. They developed a modern and animated website, just as I had requested.",
            test2: "The team at Resi Corporation did an excellent job with our website, and we highly recommend them to other businesses.",
            test3: "Thanks to Resi Corporation, we were able to modernise the design of our website. It now has a much more refined and professional look than before.",
            test4: "With the help of Resi Corporation, I was able to obtain my personal website—minimalist, modern, and built entirely without templates.",
            client: "Client",
        },
        associates: {
            name: "Associated Services",
            content: "Discover the professional services offered by Resi Corporation’s partners.",
            card1t: "Repairs & PCs",
            card1d: "Mobile phone repairs and specialised technical service for building and maintaining computers.",
            card2t: "Legal Advice",
            card2d: "Consultations in Labour Law and Inheritance, with or without a will, within Buenos Aires, Argentina.",
            card3t: "UX/UI Design",
            card3d: "Intuitive and attractive interfaces that enhance user experience and boost your digital product’s conversion.",
            card4t: "Video Editing",
            card4d: "We transform your videos into professional, engaging content optimised for social media or business use.",
            btn: "Request this service"
        }
    },

    /******************** ESPAÑOL *********************/
    es: {
        biografia: {
            name: "Biografia",
            content: "ResiCorporation es líder en desarrollo web para mercados hispanohablantes y anglosajones. Creamos y mantenemos sitios web excepcionales, optimizados y seguros."
        },
        contacto: {
            name: "Contacto"
        },
        servicios: {
            name: "Servicios",
            content: "Creación de Páginas Web y más",
            contentServicios: "Que ofrecemos",
            desarrolloWeb: "Desarrollo Web",
            contentDesarrollo: "Creamos tu sitio web desde cero con código puro, sin plantillas prearmadas como las de los constructores o CMS. Diseño 100% personalizado, adaptado a tu marca, necesidades y objetivos.",
            mantenimiento: "Mantenimiento",
            contentMantenimiento: "Primer mes incluido. Tras el desarrollo, te ofrecemos soporte mensual para mantener tu sitio al día, actualizar funciones y corregir posibles errores.",
            servidor: "Servidor",
            contentServidor: "Alojamiento incluido en el precio del desarrollo y en el mantenimiento mensual. Nos encargamos de todo para que tu sitio esté siempre online."
        },
        proyectos: {
            name: "Proyectos Completos",
            content: "+12",
            nameProyecto: "Proyectos",
            nuestrosProyectos: "Nuestros proyectos",
            verSitio: "Ver Sitio"
        },
        idiomas: {
            name: "Idiomas",
            content: "Español e Ingles"
        },
        tituloServicio: {
            name: "Contactanos",
            content: "Ponte en contacto"
        },
        hablanos: {
            name: "Hablanos"
        },
        escribenos: {
            name: "Escribenos",
            content: "Escríbenos tu proyecto"
        },
        formulario: {
            name: "Nombre Completo",
            contentName: "Escribe tu nombre completo",
            telefono: "Teléfono",
            contentTelefono: "Escribe tu teléfono",
            contentEmail: "Escribe tu email",
            proyecto: "Proyecto",
            contentProyecto: "Describe lo que buscas... ",
            enviar: "Enviar"
        },
        desarrollo: {
            habilidades: "Habilidades",
            nuestrasHabilidades: "Nuestas Habilidades",
            front: "Desarrollo Front-end",
            back: "Desarrollo Back-end"
        },
        inicio: {
            name: "Inicio",
            associates: "Asociados",
            blog: "Blog",
        },
        hero: {
            titulo: "Soluciones digitales modernas" ,
            subtitulo: "Creamos páginas web modernas, económicas y optimizadas para tu negocio. Sin constructores ni plataformas CMS: nada de WordPress, Shopify, Wix, etc. Solo desarrollo real con código limpio, pensado 100% para vos.",
            cta: "Pedí tu cotización" ,
        
        },
        testimonials: {
            name: "Testimonios",
            content: "Opiniones de nustros clientes",
            test1: "Conseguí exactamente lo que buscaba con Resi Corporation. Me desarrollaron un sitio web moderno y animado, tal como lo había solicitado.",
            test2: "El equipo de Resi Corporation hizo un excelente trabajo con nuestra página web, y los recomendamos a otras empresas.",
            test3: "Gracias a Resi Corporation, pudimos modernizar el diseño de nuestra página web. Ahora tiene un aspecto mucho más profesional y moderno que el anterior.",
            test4: "Gracias a la ayuda de Resi Corporation, pude obtener mi página web personal, con un diseño minimalista, moderno y sin uso de plantillas.",
            client: "Client",
        },
        associates: {
            name: "Servicios asociados",
            content: "Conocé los servicios profesionales ofrecidos por aliados de Resi Corporation.",
            card1t: "Reparación & PCs",
            card1d: "Reparación de celulares y servicio técnico especializado en armado y mantenimiento de computadoras.",
            card2t: "Asesoría Legal",
            card2d: "Consultas en Derecho Laboral y Sucesiones, con o sin testamento, dentro de Buenos Aires, Argentina.",
            card3t: "Diseño UX/UI",
            card3d: "Interfaces intuitivas y atractivas que mejoran la experiencia del usuario y la conversión de tu producto digital.",
            card4t: "Edición de video",
            card4d: "Transformamos tus videos en contenido profesional, atractivo y optimizado para redes sociales o uso empresarial.",
            btn: "Solicitar este servicio"
        }
    }
}

const lang = localStorage.getItem("lang");

export const translate = (word) => {
    return traducciones?.[lang]?.[word] ?? word;
}


export const changeLang = (newLang) => {
  localStorage.setItem("lang", newLang);
  location.reload();
};